// alert('도히스크립트 연결');

// Jquery

$(document).ready(function () {
  $('.columns-list').hover(
    function () {
      $(this).addClass('columns-list-hover');
      $(this).find('.column').find('*').addClass('column-txt-hover');
    },
    function () {
      $(this).removeClass('columns-list-hover');
      $(this).find('.column').find('*').removeClass('column-txt-hover');
    }
  );
});